import { createFileRoute } from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import { getCostSummary, resetCostSummary } from '../../../lib/utils/cost-meter';
import { useSync } from '../../../lib/sync/useSync';

function DiagnosticsPage() {
  const engine = useSync();
  const [summary, setSummary] = useState(() => getCostSummary());

  useEffect(() => {
    const i = setInterval(() => setSummary(getCostSummary()), 1000);
    return () => clearInterval(i);
  }, []);

  const elapsedMin = (Date.now() - summary.sessionStartedAt) / 60_000;
  const perMin = summary.totalCalls / Math.max(elapsedMin, 0.01);

  return (
    <main className="p-6 max-w-2xl space-y-6">
      <h1 className="text-2xl font-display">Diagnostics</h1>

      <section>
        <h2 className="text-sm uppercase text-fg/60 mb-1">Worker invocations this session</h2>
        <p className="text-4xl font-mono">{summary.totalCalls}</p>
        <p className="text-sm">{perMin.toFixed(1)} per minute</p>
      </section>

      <section>
        <h2 className="text-sm uppercase text-fg/60 mb-2">Per endpoint</h2>
        <table className="font-mono text-sm w-full">
          <tbody>
            {Object.entries(summary.perEndpoint).map(([path, n]) => (
              <tr key={path}>
                <td className="py-0.5">{path}</td>
                <td className="pl-4 text-right">{n}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>

      <section>
        <h2 className="text-sm uppercase text-fg/60 mb-2">Sync engine</h2>
        <pre className="text-xs bg-fg/5 p-3 rounded">
          {JSON.stringify(engine?.getDiagnostics() ?? null, null, 2)}
        </pre>
      </section>

      <button
        type="button"
        onClick={() => {
          resetCostSummary();
          setSummary(getCostSummary());
        }}
        className="border px-3 py-1 text-sm"
      >
        Reset counters
      </button>
    </main>
  );
}

export const Route = createFileRoute('/_authed/app/settings/diagnostics')({
  component: DiagnosticsPage,
});
